import script from "./GuideButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideButton.vue?vue&type=script&setup=true&lang=ts"

import "./GuideButton.vue?vue&type=style&index=0&id=bb4e26a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb4e26a8"]])

export default __exports__